module.exports = "/dashboard/manage/announcements/placeholder-1b0a40.html";